// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Cache from './lib/cache'
import iView from 'view-design'
import VueToPdf from 'vue-to-pdf'
import './theme/index.less'
import './assets/app.less'
import './assets/iconfont.css'
import './assets/iconfont.js'

Vue.use(Cache)
Vue.use(iView)
Vue.use(VueToPdf)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js